import { lazy, Suspense } from 'react';
import GuestGuard from '../components/GuestGuard';
import LoadingScreen from '../components/LoadingScreen';
import MainLayout from '../components/MainLayout';
import AuthGuard from './components/AuthGuard';
import DashboardLayout from './components/dashboard/DashboardLayout';
import SpeakerOverviewV2 from './pages/speakers/SpeakerOverviewV2';
import HCenterManagerQuitListV2 from './pages/users/HCenterManagerQuitListV2';
import StatisticsInfoManagementPubV2 from './pages/statistics/StatisticsInfoManagementPubV2';

const Loadable = (Component) => (props) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
)

// Authentication pages

// const Login = Loadable(lazy(() => import('./pages/authentication/Login')))
const PasswordRecovery = Loadable(lazy(() => import('../pages/authentication/PasswordRecovery')))
const PasswordReset = Loadable(lazy(() => import('../pages/authentication/PasswordReset')))
const Register = Loadable(lazy(() => import('../pages/authentication/Register')))
const VerifyCode = Loadable(lazy(() => import('../pages/authentication/VerifyCode')))
const Login = Loadable(lazy(() => import('./pages/auth/Login')))

// Dashboard pages
const DashboardHome = Loadable(lazy(() => import('./pages/Home')))

// EmergencyRequestOverview
const EmergencyRequestOverview = Loadable(lazy(() => import('./pages/EmergencyRequestOverview')))

// overview
const RecipientList = Loadable(lazy(() => import('./pages/users/RecipientList')))
const RecipientEdit = Loadable(lazy(() => import('./pages/users/RecipientEdit')))
const RecipientQuitList = Loadable(lazy(() => import('./pages/users/RecipientQuitListV2')))
const RecipientDetails = Loadable(lazy(() => import('./pages/users/RecipientDetails')))
const HCenterManagerList = Loadable(lazy(() => import('./pages/users/HCenterManagerList')))
const HCenterManagerEdit = Loadable(lazy(() => import('./pages/users/HCenterManagerEdit')))
const HCenterManagerQuitList = Loadable(lazy(() => import('./pages/users/HCenterManagerQuitList')))
const HCenterManagerDetails = Loadable(lazy(() => import('./pages/users/HCenterManagerDetails')))
const OperatorList = Loadable(lazy(() => import('./pages/users/OperatorList')))
const OperatorEdit = Loadable(lazy(() => import('./pages/users/OperatorEdit')))
const OperatorQuitList = Loadable(lazy(() => import('./pages/users/OperatorQuitList')))
const OperatorDetails = Loadable(lazy(() => import('./pages/users/OperatorDetails')))

const MyInfo = Loadable(lazy(() => import('./pages/users/MyInfo')))
const MyInfoEdit = Loadable(lazy(() => import('./pages/users/MyInfoEdit')))

const SpeakerOverview = Loadable(lazy(() => import('./pages/speakers/SpeakerOverview')))
const SpeakerList = Loadable(lazy(() => import('./pages/speakers/SpeakerList')))
const SpeakerEdit = Loadable(lazy(() => import('./pages/speakers/SpeakerEdit')))
const SpeakerDetailsEdit = Loadable(lazy(() => import('./pages/speakers/SpeakerDetailsEdit')))
const SpeakerIdList = Loadable(lazy(() => import('./pages/speakers/SpeakerIdList')))
const SpeakerLogin = Loadable(lazy(() => import('./pages/speakers/SpeakerLogin')))
const SpeakerDetails = Loadable(lazy(() => import('./pages/speakers/SpeakerDetails')))
// const SpeakerInWarehouseList = Loadable(lazy(() => import('./pages/speakers/SpeakerInWarehouseList')))
// const SpeakerRegister = Loadable(lazy(() => import('./pages/speakers/SpeakerRegister')))
// const SpeakerRegisterOne = Loadable(lazy(() => import('./pages/speakers/SpeakerRegisterOne')))
// const SpeakerRegisterBulk = Loadable(lazy(() => import('./pages/speakers/SpeakerRegisterBulk')))
// const SpeakerAsRegisterOne = Loadable(lazy(() => import('./pages/speakers/SpeakerAsRegisterOne')))
// const SpeakerAsRegisterBulk = Loadable(lazy(() => import('./pages/speakers/SpeakerAsRegisterBulk')))
// const SpeakerAsList = Loadable(lazy(() => import('./pages/speakers/SpeakerAsList')))
// const SpeakerAsCreate = Loadable(lazy(() => import('./pages/speakers/SpeakerAsCreate')))

const AppList = Loadable(lazy(() => import('./pages/softwares/AppList')))
const AppEdit = Loadable(lazy(() => import('./pages/softwares/AppEdit')))
const AppRead = Loadable(lazy(() => import('./pages/softwares/AppRead')))
const FotaList = Loadable(lazy(() => import('./pages/softwares/FotaList')))
const FotaWrite = Loadable(lazy(() => import('./pages/softwares/FotaWrite')))
const FotaRead = Loadable(lazy(() => import('./pages/softwares/FotaRead')))

const NoticeList = Loadable(lazy(() => import('./pages/communities/NoticeList')))
const NoticeDetails = Loadable(lazy(() => import('./pages/communities/NoticeDetails')))
const NoticeEdit = Loadable(lazy(() => import('./pages/communities/NoticeEdit')))
// 어르신 공지사항
const SilverNoticeList = Loadable(lazy(() => import('./pages/communities/SilverNoticeList')))
const SilverNoticeDetails = Loadable(lazy(() => import('./pages/communities/SilverNoticeDetails')))
const SilverNoticeEdit = Loadable(lazy(() => import('./pages/communities/SilverNoticeEdit')))
// const NoticeCreate = Loadable(lazy(() => import('./pages/communities/NoticeCreate')))
// const InstallerNoticeDetails = Loadable(lazy(() => import('./pages/communities/InstallerNoticeDetails')))
const FaqList = Loadable(lazy(() => import('./pages/communities/FaqList')))
const FaqEdit = Loadable(lazy(() => import('./pages/communities/FaqEdit')))
const FaqDetails = Loadable(lazy(() => import('./pages/communities/FaqDetails')))

const RecipientQuestionList = Loadable(lazy(() => import('./pages/communities/RecipientQuestionList')))
const RecipientQuestionEdit = Loadable(lazy(() => import('./pages/communities/RecipientQuestionEdit')))
const RecipientQuestionDetails = Loadable(lazy(() => import('./pages/communities/RecipientQuestionDetails')))
const HCenterQuestionList = Loadable(lazy(() => import('./pages/communities/HCenterQuestionList')))
const HCenterQuestionEdit = Loadable(lazy(() => import('./pages/communities/HCenterQuestionEdit')))
const HCenterQuestionDetails = Loadable(lazy(() => import('./pages/communities/HCenterQuestionDetails')))

const OneToOneQuestionList = Loadable(lazy(() => import('./pages/communities/OneToOneQuestionList')))
const OneToOneQuestionEdit = Loadable(lazy(() => import('./pages/communities/OneToOneQuestionEdit')))
const OneToOneQuestionDetails = Loadable(lazy(() => import('./pages/communities/OneToOneQuestionDetails')))

const TermsOfUseList = Loadable(lazy(() => import('./pages/communities/TermsOfUseList')))
const TermsOfUseEdit = Loadable(lazy(() => import('./pages/communities/TermsOfUseEdit')))
const TermsOfUseDetails = Loadable(lazy(() => import('./pages/communities/TermsOfUseDetails')))

const HCenterTerms = Loadable(lazy(() => import('./pages/hcenter/HCenterTerms')))
const HCenterFaq = Loadable(lazy(() => import('./pages/hcenter/HCenterFaq')))

const VitalReactionMonitoring = Loadable(lazy(() => import('./pages/VitalReactionMonitoring')))
const StatisticsInfoManagementPub = Loadable(lazy(() => import('./pages/statistics/StatisticsInfoManagementPub')))
const StatisticsInfoManagementDev = Loadable(lazy(() => import('./pages/statistics/StatisticsInfoManagementDev')))


const HCenterManagerTermsOfUse = Loadable(lazy(() => import('./pages/auth/ManagerTermsOfUse')))
const HCenterManagerRegisterPage = Loadable(lazy(() => import('./pages/auth/ManagerRegisterPage')))
const FindIdPasswordHCenter = Loadable(lazy(() => import('./pages/auth/FindIdPasswordHCenter')))

const RecipientSearch = Loadable(lazy(() => import('./pages/installer/RecipientSearch')))
const RecipientDetailsInstaller = Loadable(lazy(() => import('./pages/installer/RecipientDetailsInstaller')))
const InstallerNoticeDetails = Loadable(lazy(() => import('./pages/installer/InstallerNoticeDetails')))

// Error pages

const AuthorizationRequired = Loadable(lazy(() => import('../pages/AuthorizationRequired')))
const NotFound = Loadable(lazy(() => import('../pages/NotFound')))
const ServerError = Loadable(lazy(() => import('../pages/ServerError')))

// My DevTest
const ZRoutes = Loadable(lazy(() => import('./pages/z-devtest/ZRoutes')))


const routesCareWell = [
  {
    path: 'devtest',
    element: (
      <DashboardLayout />
    ),
    children: [
      {
        path: '/',
        element: <ZRoutes />
      }
    ]
  },
  {
    path: 'authentication',
    children: [
      {
        path: 'login',
        element: (
          <GuestGuard>
            <Login />
          </GuestGuard>
        )
      },
      {
        path: 'login-unguarded',
        element: <Login />
      },
      {
        path: 'password-recovery',
        element: <PasswordRecovery />
      },
      {
        path: 'password-reset',
        element: <PasswordReset />
      },
      {
        path: 'register-terms',
        element: (
          <GuestGuard>
            {/* <Register /> */}
            <HCenterManagerTermsOfUse />
          </GuestGuard>
        )
      },
      {
        path: 'register',
        element: (
          <GuestGuard>
            <HCenterManagerRegisterPage />
          </GuestGuard>
        )
      },
      {
        path: 'find',
        element: (
          <GuestGuard>
            <FindIdPasswordHCenter />
          </GuestGuard>
        )
      },
      {
        path: 'register-unguarded',
        element: <Register />
      },
      {
        path: 'verify-code',
        element: <VerifyCode />
      }
    ]
  },
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    // outlets
    children: [
      {
        path: 'my-info/view',
        element: <MyInfo />
      },
      {
        path: 'my-info/edit',
        element: <MyInfoEdit />
      },
      {
        path: '/',
        element: <DashboardHome />
      },
      {
        path: '/emergency-req',
        element: <EmergencyRequestOverview />
      },
      {
        path: 'vital-reaction',
        element: <VitalReactionMonitoring />
      },
      {
        path: '/installer',
        children: [
          {
            path: '/search',
            element: <RecipientSearch />
          },
          {
            path: '/notices/:id/details',
            element: <InstallerNoticeDetails />
          },
        ]
      },
      {
        path: 'users',
        // element: <Account />
        children: [
          {
            path: '/',
            element: <RecipientList />
          },
          //------------------------------------------
          {
            path: 'recipients',
            element: <RecipientList />
          },
          {
            path: 'recipients/:id/details',
            element: <RecipientDetails />
          },
          {
            path: 'recipients/:id/details-quit',
            element: <RecipientDetails />
          },
          {
            path: 'recipients/:id/edit',
            element: <RecipientEdit />
          },
          {
            path: 'recipients/new',
            element: <RecipientEdit />
          },
          {
            path: 'recipients/new-many',
            element: <RecipientEdit />
          },
          {
            path: 'recipients-quit',
            element: <RecipientQuitList />
          },
          //------------------------------------------
          {
            path: 'hcenter-managers',
            element: <HCenterManagerList />
          },
          {
            path: 'hcenter-managers/:id/details',
            element: <HCenterManagerDetails />
          },
          {
            path: 'hcenter-managers/:id/edit-profile',
            element: <HCenterManagerEdit />
          },
          {
            path: 'hcenter-managers/:id/details-quit',
            element: <HCenterManagerDetails />
          },
          {
            path: 'hcenter-managers/:id/edit',
            element: <HCenterManagerEdit />
          },
          {
            path: 'hcenter-managers/new',
            element: <HCenterManagerEdit />
          },
          {
            path: 'hcenter-managers-quit',
            element: <HCenterManagerQuitListV2 />
          },
          //------------------------------------------
          {
            path: 'operators',
            element: <OperatorList />
          },
          {
            path: 'operators/:id/details',
            element: <OperatorDetails />
          },
          {
            path: 'operators/:id/details-quit',
            element: <OperatorDetails />
          },
          {
            path: 'operators/:id/edit',
            element: <OperatorEdit />
          },
          {
            path: 'operators/new',
            element: <OperatorEdit />
          },
          {
            path: 'operators-quit',
            element: <OperatorQuitList />
          },
          //------------------------------------------
          {
            path: 'recipients/:id/details-ins',
            element: <RecipientDetailsInstaller />
          },
        ]
      },
      {
        path: 'speakers',
        // element: <Account />
        children: [
          //------------------------------------------
          {
            path: '/overview',
            element: <SpeakerOverviewV2 />
          },
          {
            path: '/',
            element: <SpeakerList />
          },
          {
            path: '/:id/details',
            element: <SpeakerDetails />
          },
          {
            path: '/:id/edit',
            element: <SpeakerEdit />
          },
          {
            path: '/:id/details-edit',
            element: <SpeakerDetailsEdit />
          },
          {
            path: '/new',
            element: <SpeakerEdit />
          },
          {
            path: '/new-many',
            element: <SpeakerEdit />
          },
          {
            path: '/idlist',
            element: <SpeakerIdList />
          },
          {
            path: '/login',
            element: <SpeakerLogin />
          },
        ]
      },
      {
        path: 'softwares',
        children: [
          {
            path: '/',
            element: <AppList />
          },
          {
            path: 'apps',
            element: <AppList />
          },
          {
            path: 'apps/new',
            element: <AppEdit />
          },
          {
            path: 'apps/:id/details',
            element: <AppRead />
          },
          {
            path: 'apps/:id/edit',
            element: <AppEdit />
          },
          {
            path: 'fota',
            element: <FotaList />
          },
          {
            path: 'fota/new',
            element: <FotaWrite />
          },
          {
            path: 'fota/:id/details',
            element: <FotaRead />
          },
          {
            path: 'fota/:id/edit',
            element: <FotaWrite />
          },
        ]
      },

      {
        path: 'communities',
        children: [
          {
            path: '/',
            element: <NoticeList />
          },
          {
            path: 'notices',
            element: <NoticeList />
          },
          {
            path: 'notices/:id/details',
            element: <NoticeDetails />
          },
          {
            path: 'notices/:id/edit',
            element: <NoticeEdit />
          },
          {
            path: 'notices/new',
            element: <NoticeEdit />
          },
          //------------------------------------------
          {
            path: 'silver_notices',
            element: <SilverNoticeList />
          },
          {
            path: 'silver_notices/:id/details',
            element: <SilverNoticeDetails />
          },
          {
            path: 'silver_notices/:id/edit',
            element: <SilverNoticeEdit />
          },
          {
            path: 'silver_notices/new',
            element: <SilverNoticeEdit />
          },
          //------------------------------------------
          {
            path: 'faqs',
            element: <FaqList />
          },
          {
            path: 'faqs/:id/details',
            element: <FaqDetails />
          },
          {
            path: 'faqs/:id/edit',
            element: <FaqEdit />
          },
          {
            path: 'faqs/new',
            element: <FaqEdit />
          },
          //------------------------------------------
          {
            path: 'recipient-questions',
            element: <RecipientQuestionList />
          },
          {
            path: 'recipient-questions/:id/details',
            element: <RecipientQuestionDetails />
          },
          {
            path: 'recipient-questions/:id/edit',
            element: <RecipientQuestionEdit />
          },
          {
            path: 'recipient-questions/new',
            element: <RecipientQuestionEdit />
          },
          //------------------------------------------
          {
            path: 'hcenter-questions',
            element: <HCenterQuestionList />
          },
          {
            path: 'hcenter-questions/:id/details',
            element: <HCenterQuestionDetails />
          },
          {
            path: 'hcenter-questions/:id/edit',
            element: <HCenterQuestionEdit />
          },
          {
            path: 'hcenter-questions/new',
            element: <HCenterQuestionEdit />
          },
          //------------------------------------------
          {
            path: 'terms',
            element: <TermsOfUseList />
          },
          {
            path: 'terms/:id/details',
            element: <TermsOfUseDetails />
          },
          {
            path: 'terms/:id/edit',
            element: <TermsOfUseEdit />
          },
          {
            path: 'terms/new',
            element: <TermsOfUseEdit />
          },
          //------------------------------------------
          {
            path: '1to1-questions',
            element: <OneToOneQuestionList />
          },
          {
            path: '1to1-questions/:id/details',
            element: <OneToOneQuestionDetails />
          },
          {
            path: '1to1-questions/:id/edit',
            element: <OneToOneQuestionEdit />
          },
          {
            path: '1to1-questions/new',
            element: <OneToOneQuestionEdit />
          },
          //------------------------------------------
          {
            path: 'terms',
            element: <TermsOfUseList />
          },
          {
            path: 'hcenter-terms',
            element: <HCenterTerms />
          },
          {
            path: 'hcenter-faqs',
            element: <HCenterFaq />
          }

        ]
      },
      {
        path: 'statistics',
        children: [
          {
            path: '/',
            element: <StatisticsInfoManagementPubV2 />
          },
        ]
      }
      // {
      //   path: 'statistics',
      //   children: [
      //     {
      //       path: '/',
      //       element: process.env.REACT_APP_PUB_ENV === 'DEV' ? <StatisticsInfoManagementDev /> : <StatisticsInfoManagementPub />
      //     },
      //   ]
      // },
    ]
  },
  {
    path: '/',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '/',
        element: <DashboardHome />
      }
    ]
  },
  {
    path: '*',
    element: <MainLayout />,
    children: [
      {
        path: '401',
        element: <AuthorizationRequired />
      },
      {
        path: '404',
        element: <NotFound />
      },
      {
        path: '500',
        element: <ServerError />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
]

export default routesCareWell
